import { navigateTo } from "./navigationService";
import { UPDATE_NOTIFICATION_STATUS } from "./constant/Apipath";
import { setOpenNotificationMenu, setPreviousQuestionId } from "./redux/actions/actions";
import { Postrequestcall } from "./request/Postrequest";
import { navigateToChatPage, navigateToClientChatPage } from "./common/Helper";
import store from "./redux/store/store";

export const constructUrl = (baseUrl, path, params) => {
    let baseUrlNew = baseUrl || import.meta.env.REACT_APP_BASE_URL || window.location.origin;
    const url = new URL(baseUrlNew);
    url.pathname = path;
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });
    return url.toString();
};

export const handleUpdateNotificationStatus = async (msgId, loginData) => {
    try {
        if (!msgId || msgId == "0") {
            return;
        }
        const currentLoginData = store.getState()?.main?.loginData || loginData;
        if (!currentLoginData?.accessToken) {
            console.warn("handleUpdateNotificationStatus: No access token available in loginData or Redux store");
            return;
        }
        const obj = {
            NotificationMessageId: msgId,
            ReceiverUserDevice: loginData?.userInformation?.DeviceId
        };
        await Postrequestcall(UPDATE_NOTIFICATION_STATUS, obj, currentLoginData?.accessToken);
    } catch (err) {
        console.log("handleUpdateNotificationStatus-> Error When Updating Notification Status", err);
        throw err;
    }
};

export const handleNotificationClick = async (item, itemUrl, dispatch, loginData) => {
    try {
        const currentLoginData = store.getState()?.main?.loginData || loginData;
        if (item !== undefined) {
            const url = item["gcm.n.link"];
            let screenName = "";
            let matchId = "";
            let clientId = "";

            function parseURL(urlString) {
                const urlWithoutProtocol = urlString.replace("mybuilderid://", "");
                const screenNameMatch = urlWithoutProtocol.match(/screenName=([^&]+)/);
                const idMatch = urlWithoutProtocol.match(/id=([^&]+)/);
                const clientIdMatch = urlWithoutProtocol.match(/ClientId=([^&]+)/);

                let screenName = screenNameMatch ? screenNameMatch[1] : null;
                const matchId = idMatch ? idMatch[1] : null;
                const clientId = clientIdMatch ? clientIdMatch[1] : null;

                if (!screenName) {
                    const [path] = urlWithoutProtocol.split("&");
                    screenName = path;
                }
                return { screenName, matchId, clientId };
            }

            const { screenName: parsedScreenName, matchId: parsedId, clientId: parsedClientId } = parseURL(url);

            screenName = parsedScreenName || "";
            if (screenName.includes("?")) {
                screenName = screenName.split("?")[0];
            }
            matchId = parsedId || "";
            clientId = parsedClientId || "";
            let urlWithState;
            switch (screenName) {
                case "DashboardNotifications":
                    dispatch(setOpenNotificationMenu(true));
                    break;
                case "Sites":
                    navigateTo(`/sites`);
                    break;
                case "Community":
                    navigateTo(`/community`);
                    break;
                case "Chat":
                    navigateTo(`/chat`);
                    break;
                case "Trades":
                    navigateTo(`/trades`);
                    break;
                case "Products":
                    navigateTo(`/products`);
                    break;
                case "Manufactures":
                    navigateTo(`/manufactures`);
                    break;
                case "Companies":
                    navigateTo(`/companies`);
                    break;
                case "BuilderNetwork":
                    navigateTo(`/contacts`);
                    break;
                case "Montage":
                    navigateTo(`/montages`);
                    break;
                case "ResumeBuilder":
                    navigateTo(`/resume-builder`);
                    break;
                case "Carpool":
                    navigateTo(`/carpool`);
                    break;
                case "JobPosting":
                case "JobPostings":
                    const isExternal = url.includes("?External");
                    navigateTo(`/job-postings`, {
                        state: { jobId: matchId, isExternal: isExternal }
                    });
                    break;
                case "Expenses":
                    navigateTo(`/expenses`);
                    break;
                case "Timesheet":
                    navigateTo(`/timesheets`);
                    break;
                case "BuySell":
                    navigateTo(`/buy-sell`);
                    break;
                case "Tickets":
                    navigateTo(`/tickets`);
                    dispatch(setOpenNotificationMenu(true));
                    break;
                case "RewardStore":
                    navigateTo(`/reward-store`);
                    break;
                case "CompanyInfo":
                    navigateTo(`/company/${matchId}`);
                    break;
                case "ManufacturerInfo":
                    navigateTo(`/manufacturer/${matchId}`);
                    break;
                case "ProductInfo":
                    navigateTo(`/product/${matchId}`);
                    break;
                case "TradeDetail":
                    navigateTo(`/trade/${matchId}`);
                    break;
                case "ProjectPage":
                    navigateTo(`/project/${matchId}`);
                    break;
                case "ConversationScreen":
                    navigateToChatPage(navigateTo, dispatch, "notification", "", "", Number(matchId), "");
                    break;
                case "ContactProfile":
                    navigateTo(`/${matchId}`);
                    break;
                case "DetailPost":
                    navigateTo("/community", {
                        state: { item: { custom1: Number(matchId) }, from: "from-notification", postRefresh: new Date().getTime() }
                    });
                    break;
                case "MapForSingleSite":
                    navigateTo("/home", {
                        state: { notificationId: Number(matchId), from: "from-notification" }
                    });
                    break;
                case "ProfileBoard":
                    navigateTo(`${currentLoginData?.userInformation?.UserId}`, {
                        from: "NotificationsForProfile"
                    });
                    break;
                case "MyExperience":
                    navigateTo(`${currentLoginData?.userInformation?.UserId}`, {
                        from: "NotificationsForProfile"
                    });
                    break;
                case "DashboardNotifications":
                    urlWithState = constructUrl(itemUrl, "dashboard", {
                        from: "NotificationsForNotify"
                    });
                    navigateTo("/", urlWithState);
                    break;
                case "Quiz":
                    dispatch(setPreviousQuestionId(Number(matchId)));
                    navigateTo("/reward-store/earn-builderbucks/earn-rewards");
                    break;
                case 'ClientConversationScreen':
                    navigateToClientChatPage(navigateTo, Number(clientId), Number(matchId));
                    break;
                case "DailyChallenge":
                case "DailyChallengeCard":
                    navigateTo("/home", {
                        state: {
                            from: "from-notification",
                            showDailyChallenge: true,
                            openDailyChallengeModal: true,
                            refresh: new Date().getTime()
                        }
                    });
                    break;
                default:
                    navigateTo(`/`);
                    break;
            }
            await handleUpdateNotificationStatus(item?.NotificationMessageId, currentLoginData);
        } else {
            console.error("handleNotificationClick-> No screen name or ID found in the input string");
        }
    } catch (error) {
        console.log("handleNotificationClick-> Error When Handling Notification Click", error);
    }
};
